import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import * as modifyMessageActions from './modify-message.actions';
import * as messageSections from './message-section-constants';
import ModifyMessageForm from './modify-message-form';
import { LoadingPane, ConfirmModalWindow, accessibilityNotificationsEmitter } from '../../common';
import { Title } from '../../layout';
import { toastr } from 'react-redux-toastr';
import * as modifyMessageUtilities from './modify-message-utilities';

const modalText = "No Start or End Date entered. Do you want to publish this notification without a date range?";
export class EditMessageComponent extends Component {

  componentDidMount() {
    const { modifyMessageActions, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { fetchMessage, validateForm } = modifyMessageActions;
    fetchMessage(id);
    validateForm(['editValues', id], ['dashboardMessages', id, 'data'], ['editValuesValidation', id]);
  }

  componentWillUpdate(nextProps, nextState) {
    const { modifyMessage, modifyMessageActions, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { fetchMessage, validateForm } = modifyMessageActions;
    const { editValues, dashboardMessages } = modifyMessage;
    const { editValues : newValues, dashboardMessages : newMessages } = nextProps.modifyMessage;
    fetchMessage(id);
    if(editValues !== newValues || dashboardMessages !== newMessages)
      validateForm(['editValues', id], ['dashboardMessages', id, 'data'], ['editValuesValidation', id]);
  }

  componentDidUpdate(prevProps, prevState) {
    const { modifyMessage : prevMessageState } = prevProps;
    const { showDateRangeConfirmModal : wasShowing } = prevMessageState || {};
    const { modifyMessage } = this.props;
    const { showDateRangeConfirmModal : isShowing } = modifyMessage || {};
    if(isShowing && !wasShowing) {
      var modalFocusTarget = document.getElementById('modal-content');
      if(modalFocusTarget) modalFocusTarget.focus();
    }
    else if(!isShowing && wasShowing) {
      var viewFocusTarget = document.getElementById('view');
      if(viewFocusTarget) viewFocusTarget.focus();
    }
  }

  onConfirmModalClose(e, result) {
    const { modifyMessageActions, match } = this.props;
    const { params } = match || {};
    const { closeDateRangeConfirmModal } = modifyMessageActions;
    const { id } = params || {};

    if(!!result) {
      this.handleUpdateValue(messageSections.dateRangeSection, false);
      this.handleUpdateValue(messageSections.startSection, "");
      this.handleUpdateValue(messageSections.endSection, "");

      this.saveMessage(id);
    }
    closeDateRangeConfirmModal();
  }

  saveMessage(id) {
    const { modifyMessageActions, redirectTo } = this.props;
    const { updateMessage } = modifyMessageActions;

    updateMessage(id)
      .then(val => {
        toastr.success('Success', 'Notification Updated');
        redirectTo('/dashboard-messages');
      })
      .catch(err => {
        toastr.error(err.errorCode, err.errorMessage);
      });
  }

  handleUpdateMessage() {
    const { modifyMessage, modifyMessageActions, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { editValuesValidation, editValues, dashboardMessages } = modifyMessage;
    const { showEditValidation, showDateRangeConfirmModal } = modifyMessageActions;

    const validation = editValuesValidation && editValuesValidation.get(id);
    if(validation && validation.length > 0) {
      showEditValidation(id);
      return;
    }

    const value = editValues && editValues.get(id);
    const rawOldData = dashboardMessages && dashboardMessages.getIn([id, 'data']);
    var defaultValues = modifyMessageUtilities.convertMessageToUiFormat(rawOldData);
    const mergedValue = modifyMessageUtilities.mergeData(value, defaultValues);
    const useDateRange = mergedValue.useDateRange;
    const publishStartDate = mergedValue.publishStartDate;
    const publishEndDate = mergedValue.publishEndDate;
    const confirmSubmit = useDateRange &&
      (publishStartDate === null || publishStartDate === undefined || publishStartDate === "") &&
      (publishEndDate === null || publishEndDate === undefined || publishEndDate === "");

    //if displaying message on certain days, but no dates are set, then show confirm modal
    if(confirmSubmit) {
      accessibilityNotificationsEmitter.assertive(modalText);
      showDateRangeConfirmModal();
      return;
    }

    this.saveMessage(id);
  }

  handleUpdateValue(section, updateVal) {
    const { modifyMessageActions, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { updateValue, validateForm } = modifyMessageActions || {};

    updateValue(['editValues', id, section], updateVal);
    validateForm(['editValues', id], ['dashboardMessages', id, 'data'], ['editValuesValidation', id]);
  }

  render() {
    const { modifyMessage, redirectTo, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { editValues, dashboardMessages, updateMessageState, editValuesValidation, showEditValidation, showDateRangeConfirmModal } = modifyMessage || {};
    const messageState = dashboardMessages && dashboardMessages.get(id);
    const updateState = updateMessageState && updateMessageState.get(id);
    const { isFetching, err, data } = messageState || { isFetching : false };
    const { isFetching : isSaving } = updateState || { isFetching : false };

    const value = editValues && editValues.get(id);
    const defaultValue = modifyMessageUtilities.convertMessageToUiFormat(data);
    const errors = editValuesValidation && editValuesValidation.get(id);
    const showErrors = showEditValidation && showEditValidation.get(id);

    const invalidForm = !errors || errors.length > 0;

    return (
      <LoadingPane isLoading={isFetching} err={err} loadingMessage={'Loading notification...'}>
        <Title title="Edit Notification"/>
        <h1>Edit Notification</h1>
        <ModifyMessageForm
          value={value}
          defaultValue={defaultValue}
          updateValue={(section, updateVal) => this.handleUpdateValue(section, updateVal)}
          disabled={isSaving}
          errors={errors}
          showErrors={showErrors}/>
        <div className="actions">
          <button
            id='update'
            className="btn btn-primary"
            onClick={e => this.handleUpdateMessage()}
            disabled={isSaving || invalidForm || !value}>
            <span>Update</span>
          </button>
          <button
            id='cancel'
            className="btn btn-default"
            onClick={e => redirectTo('/dashboard-messages')}>
            Cancel
          </button>
        </div>
        <ConfirmModalWindow
            show={showDateRangeConfirmModal}
            title={"Publish Notification"}
            onClose={(e, result) => this.onConfirmModalClose(e, result) }>
          <div className="form-horizontal survey">
            <p>{modalText}</p>
          </div>
        </ConfirmModalWindow>
      </LoadingPane>
    );
  }
}

EditMessageComponent.propTypes = {
  modifyMessage : PropTypes.any,
  modifyMessageActions : PropTypes.any,
  redirectTo : PropTypes.func
};

const mapStateToProps = ({ modifyMessage }) => {
  return {
    modifyMessage
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    modifyMessageActions: bindActionCreators(modifyMessageActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditMessageComponent);
